import { openWinStreakSharePopup } from './openWinStreakSharePopup';
import { endCurrentEvent } from '../WinStreakUtils';
import type { WinStreakDependencies } from '../WinStreakController';

export async function endWinStreakAndOpenShare(dependencies: WinStreakDependencies): Promise<void> {
  const { observable, tracking } = dependencies;

  const sharePromise = openWinStreakSharePopup(dependencies);
  const state = observable.getValue().winStreakActiveEvent;
  if (state) tracking.onEventFinished(state.id, state?.currentProgress);
  if (state) endCurrentEvent(dependencies.observable);
  return sharePromise;
}
